import * as PropTypes from "prop-types";
import {Component} from "react";
import * as React from "react";
import {Card, CardBody, CardHeader} from "reactstrap";
import * as adresaFormatter from "../utils/adresaFormatter";
import {formatTime, formatDate} from "../utils/utils";
import {getUplnaAdresa} from "../utils/adresaFormatter";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Jednoduchý read-only panel zobrazující způsob dodání.
 */
class ZpusobDodaniPanel extends Component<WithTranslation> {

    static propTypes = {
        pobocka: PropTypes.object, // VO pobočky, musí být předáno pokud není předána adresa
        adresa: PropTypes.object, // VO adresy, musí být předáno pokud není předána pobočka
        datum: PropTypes.string.isRequired, // datum vyzvednutí/dodání jako string (2018-12-30T00:00:00.000)
        casVyzvednuti: PropTypes.string, // čas vyzvednutí jako string (10:00:00.00)
        terminDoprava: PropTypes.object, // VO termínu dopravy při dodání na adresu
    };

    render() {
        const {pobocka, adresa, datum, casVyzvednuti, terminDoprava, t} = this.props;
        const ulice = pobocka ? pobocka.ulice : null;
        const obec = pobocka ? pobocka.obec : null;
        const psc = pobocka ? pobocka.psc : null;
        const misto = pobocka && pobocka.nazevPobocka ? t('pickup_at_branch', {branchName: pobocka.nazevPobocka, address: getUplnaAdresa({ulice, obec, psc})}) : adresa ? t('delivery_to_address', {address: adresaFormatter.getUplnaAdresa(adresa)}) : null;
        const datumString = formatDate(datum, null, "D.M.YYYY");
        const casString = formatTime(casVyzvednuti, "HH:mm:ss.SS");
        const casOdString = terminDoprava ? formatTime(terminDoprava.casDoruceniOd) : null;
        const casDoString = terminDoprava ? formatTime(terminDoprava.casDoruceniDo) : null;
        const nazevDopravy = terminDoprava ? terminDoprava.zpusobDoprava.nazevDoprava : null;
        // const nazevTermin = terminDoprava ? terminDoprava.nazevTermin : null;

        let content = "";
        if (pobocka) {
            content = `${misto ? `${misto}, ` : ""}${datumString && casString ? `${datumString} ${t('after').toLowerCase()} ${casString}` : ""}`;
        } else if (adresa) {
            content = `${misto ? `${misto}, ` : ""}${datumString ? `${t('date').toLowerCase()} ${datumString}, ` : ""}${casOdString && casDoString ? `${t('between').toLowerCase()} ${casOdString} ${t('and').toLowerCase()} ${casDoString}, ` : ""}${nazevDopravy ? `${t('way_of_delivery').toLowerCase()}: ${nazevDopravy}` : ""}`;
        }

        return <Card>
            <CardHeader>
                <h2>{t('way_of_delivery')}</h2>
            </CardHeader>
            <CardBody>
                {content}
            </CardBody>
        </Card>
    }
}

export default withTranslation()(ZpusobDodaniPanel);
